import Button from "@mui/material/Button";
import { useCallback, useEffect } from "react";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { useTranslation } from "react-i18next";

interface ButtonSubmitFormProps {
  disabled?: boolean;
  submitForm: (token: string) => void;
}

export default function ButtonSubmitForm(props: ButtonSubmitFormProps) {
  const { disabled = false, submitForm } = props;
  const { t } = useTranslation();
  const { executeRecaptcha } = useGoogleReCaptcha();

  // Create an event handler so you can call the verification on button click event or form submit
  const handleReCaptchaVerify = useCallback(async () => {
    if (!executeRecaptcha) {
      return;
    }

    const token = await executeRecaptcha("form");
    submitForm(token);
  }, [executeRecaptcha]);

  // You can use useEffect to trigger the verification as soon as the component being loaded
  useEffect(() => {
    handleReCaptchaVerify();
  }, [handleReCaptchaVerify]);

  return (
    <Button
      size="large"
      variant="contained"
      onClick={handleReCaptchaVerify}
      disabled={disabled}
      type="submit"
    >
      {t("submit")}
    </Button>
  );
}
